/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Loading...',
	'dlg_close': 'Close',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Cancel',
	'dlg_back': 'Go back',
	'dlg_done': 'Done',
	'dlg_save': 'Save',

	// Slider
	'sliderRegionLabel': 'Slider control, use right and left arrows to move the slider handles',
	'sliderHandleLabel': 'Slider handle',
	'a11ySliderHandleLabel': 'Slider handle %{sliderValue}',
	'sliderInputLabel': 'value',

	// Side bar
	'sidebarAdd': 'Add',
	'clearTextFilterValue': 'Clear',
	'missingDataSetData': 'The data for this data set is not available. Refresh the data set or contact your administrator for access to the source.',

	// Toolbar
	'toolbarRegionLabel': 'Toolbar',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Font family',
	'fontFamilyStyle': 'Font style',
	'regularFontStyle': 'Regular',
	'fontSizeSelect': 'Font size',
	'fontColorSelect': 'Color',
	'fontStyle': 'Style',
	'colorPickerTitle': 'Selecting a color',
	'bold': 'Bold',
	'italic': 'Italic',
	'underline': 'Underline',
	'fontAlignment': 'Alignment',
	'justifyLeft': 'Align left',
	'justifyCenter': 'Align center',
	'justifyRight': 'Align right',
	'insertOrderedList': 'Ordered List',
	'insertUnorderedList': 'Unordered List',
	'fontColorPicker': 'Color picker',
	'textWrap': 'Wrap text',
	'restore': 'Restore defaults',
	'textAutoFontSize': 'Auto',
	'textDefaultFontSize': 'Default',
	'textItemTitle': 'Title',
	'textLabelShadow': 'Label shadow',
	'textContrastLabelColor':'Contrast color',
	'toggleOn': 'On',
	'toggleOff': 'Off',
	'contrastLabelColorInfo': 'Auto adjust label color for accessibility. This overrides the font color.',
	'labelShadowInfo':'Add shadow to text for accessibility.',
	'applyToAll':'Apply styling to all axes',

	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Number of results (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Percent (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Top or bottom option',
	'topbottomOptionLabel': 'Show',
	'searchByLabel': 'By',
	'searchNoMatches': 'No matches found',
	'topbottomRankColumnLabel': 'Add a rank column to table',
	'topbottomNone': 'None',
	'topCount': 'Top count',
	'topPercent': 'Top %',
	'bottomCount': 'Bottom count',
	'bottomPercent': 'Bottom %',
	'searchColumn': 'Find a column',
	'searchColumnAriaLabel': 'Find a column. Type the name of the column to search for then use the down arrow to find the column in a list',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Rank (%{columnLabel})',
	'topbottomClearLabel': 'Reset',

	// Format
	'formatAuto': 'Auto',
	'formatConvertPercent': 'Convert decimal to percentage',
	'formatAbbreviate': 'Abbreviate',
	'formatUseGrouping': 'Use thousands separator',
	'dateStyle': 'Date style',
	'dateTimeStyle': 'Date/Time style',
	'formatMissingValueCharactersInfo': 'Missing value characters specifies the characters to be displayed when the value is missing.',
	'currencySymbolLabel': 'Currency symbol',
	'customSymbolPlaceholder': 'Add a symbol',
	'customSymbolLabelInfo': 'Specifies a character or characters to use as a custom symbol. This symbol will precede the number and any sign.',
	'numberLabel': 'Number label',
	'numberPositionLabel': 'Label position',
	'negativeSignPosition': 'Negative sign position',
	'negativeSign': 'Negative sign symbol',
	'numberLabelInfo': 'Specifies a label for the formatted number and placed as a prefix or suffix depending on the label position.',
	'nullValueDefault': '<default>',
	'nullValueContent': '(no value)',
	'default': 'Default',
	'beginning': 'Beginning',
	'end': 'End',
	'formatLabel': 'Select a format',

	// More data indicator
	'moreDataIndicator': 'Your data was clipped at %{threshold} items. Apply a filter to show less.',

	// Expanded View / Focus mode
	'evCollapse': 'Collapse',
	'duplicate': 'Duplicate',
	'copyOf': 'Copy of %{name}',
	'unableToDuplicateBoard': 'Unable to duplicate "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'We can\'t load the objects.',

	// Custom widgets
	'customWidget': 'Custom widget',

	// Auto group
	'group': 'Group',

	// TODO: Carbon design removes Font Family subClass, no longer needed when FF 'PropertiesV2' is enabled
	// START: Remove FontFamilySubClass
	'textFontFamilySubClassHairline': 'Hairline',
	'textFontFamilySubClassThin': 'Thin',
	'textFontFamilySubClassThinItalic': 'Thin Italic',
	'textFontFamilySubClassExtraLight': 'Extra Light',
	'textFontFamilySubClassExtraLightItalic': 'Extra Light Italic',
	'textFontFamilySubClassLight': 'Light',
	'textFontFamilySubClassLightItalic': 'Light Italic',
	'textFontFamilySubClassRegular': 'Regular',
	'textFontFamilySubClassRegularItalic': 'Regular Italic',
	'textFontFamilySubClassItalic': 'Italic',
	'textFontFamilySubClassMedium': 'Medium',
	'textFontFamilySubClassMediumItalic': 'Medium Italic',
	'textFontFamilySubClassHeavy': 'Heavy',
	'textFontFamilySubClassHeavyItalic': 'Heavy Italic',
	'textFontFamilySubClassDemiBold': 'Demi Bold',
	'textFontFamilySubClassDemiBoldItalic': 'Demi Bold Italic',
	'textFontFamilySubClassBold': 'Bold',
	'textFontFamilySubClassBoldItalic': 'Bold Italic',
	'textFontFamilySubClassExtraBold': 'Extra Bold',
	'textFontFamilySubClassExtraBoldItalic': 'Extra Bold Italic',
	'textFontFamilySubClassBlack': 'Black',
	'textFontFamilySubClassBlackItalic': 'Black Italic',
	'textFontFamilySubClassStencil': 'Stencil',
	// END: Remove FontFamilySubClass
});
